import { logWrapper } from '../utils';

function fileReadDirectiveFactory(runtimeConstant) {
  function link(scope, element) {
    element.bind('change', (changeEvent) => {
      scope.$apply(() => {
        scope.fileread = changeEvent.target.files[0];
      });
    });
  }

  function run() {
    return {
      scope: {
        fileread: '=',
      },
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const fileReadDirective = ['runtimeConstant', fileReadDirectiveFactory];
